export class Stampqrcode {
  id: number;
  positionX: number;
  positionY: number;
  sideSize: number;
  pageStamp: number;
  stampOn: number;
  active: number;
}
